import { Text } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";
import { Button } from "@src/appV2/redesign/components/Button";
import { DestructiveHoldToConfirmButton } from "@src/appV2/redesign/components/DestructiveHoldToConfirmButton";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";
import { TextButton } from "@src/appV2/redesign/components/TextButton";
import { ShieldIcon } from "@src/appV2/redesign/EmergencyCredits/components/ShieldIcon";

interface ShiftCancelFooterProps {
  variant: "preview-credit" | "cancel-shift";
  showWhyCantIUseCredit?: boolean;
  isCancelling?: boolean;
  isPreviewAnimating?: boolean;
  onKeepShift: () => void;
  onPressAndHoldToCancel: () => void;
  onPreviewCredit: () => void;
  onWhyCantIUseCredit?: () => void;
}

export function ShiftCancelFooter(props: ShiftCancelFooterProps): JSX.Element {
  const {
    variant,
    showWhyCantIUseCredit = false,
    isCancelling = false,
    isPreviewAnimating = false,
    onKeepShift,
    onPressAndHoldToCancel,
    onPreviewCredit,
    onWhyCantIUseCredit,
  } = props;

  const isCancelDisabled = isCancelling || isPreviewAnimating;

  const isPreviewCreditVariant = variant === "preview-credit";

  return (
    <DialogFooter orientation="vertical" sx={{ marginTop: "auto" }}>
      <Stack spacing={3} sx={{ width: "100%" }}>
        {showWhyCantIUseCredit && (
          <TextButton
            underline
            sx={(theme) => ({
              color: theme.palette.primary.main,
              alignSelf: "center",
            })}
            onClick={onWhyCantIUseCredit}
          >
            Why can&apos;t I use my cancellation credit?
          </TextButton>
        )}
        {isPreviewCreditVariant ? (
          <Button
            fullWidth
            variant="contained"
            size="large"
            disabled={isPreviewAnimating}
            sx={(theme) => ({
              "&.Mui-disabled": {
                backgroundColor: theme.palette.intent?.disabled.background,
                border: `1px solid ${theme.palette.border?.primary}`,
              },
            })}
            onClick={onPreviewCredit}
          >
            <Stack direction="row" spacing={4} alignItems="center">
              <ShieldIcon variant="filled" sx={{ fontSize: 16 }} />
              <Text color="inherit">Preview my cancellation credit</Text>
            </Stack>
          </Button>
        ) : (
          <DestructiveHoldToConfirmButton
            isLoading={isCancelling}
            disabled={isCancelDisabled}
            onConfirm={onPressAndHoldToCancel}
          >
            {isCancelling ? "Cancelling..." : "Press and hold to cancel"}
          </DestructiveHoldToConfirmButton>
        )}
        <Button
          fullWidth
          variant="contained"
          size="large"
          disabled={isCancelling}
          onClick={onKeepShift}
        >
          Keep my shift
        </Button>
      </Stack>
    </DialogFooter>
  );
}
